import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import Viewer from './components/Viewer';
import ContentList from './components/ContentList';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import Bookmarks from './components/Bookmarks';
import InstallPWA from './components/InstallPWA';
import './App.css';

// 릴리즈인 경우 console.log를 제거한다.
if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<ContentList />} />
          <Route path="/viewer/:id/:accessKey" element={<Viewer />} />
          <Route path="/bookmarks" element={<Bookmarks />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
        <InstallPWA />
      </div>
    </Router>
  );
}

export default App;
